import './KPIGrid.css';

export function KPIGrid({ children, columns }) {
  const style = columns ? { gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` } : undefined;
  return <div className="ui-kpi-grid" style={style}>{children}</div>;
}
